import React from "react";
import Layout from "../../../components/Layouts/Layouts/Layout";
import DashboardHeader from "../../../components/basic/DashboardHeader";
import MasterNavigationBar from "../../../components/Layouts/Layouts/MasterServicesLayout";
import { useNavigate } from "react-router-dom";
import { getAuthUserCookie } from "../../../store/services";

const MasterCollaborationPortal = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <MasterNavigationBar>
        <div className="d-flex flex-column px-3">
          <DashboardHeader
            heading="COLLABORATION PORTAL"
            backUrl="/master-dashboard"
          />
          <hr />
          <div className="d-flex justify-content-around mb-2">
            <button
              type="button"
              className="bg-color border-0 mt-4 p-2 px-3 rounded-1"
              style={{ width: "35%" }}
              onClick={() => {
                navigate("/master-collaboration-portal-list");
              }}
            >
              COLLABORATION PORTAL
            </button>
            <button
              type="button"
              className="bg-color border-0 mt-4 p-2 px-3 rounded-1"
              style={{ width: "35%" }}
              onClick={() => {
                navigate("/master-collaborator-renewals");
              }}
            >
              COLLABORATOR RENEWALS
            </button>
          </div>
        </div>
      </MasterNavigationBar>
    </Layout>
  );
};

export default MasterCollaborationPortal;
